<template>
    <div class="container py-5">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div
                    class="row g-4 align-items-center p-4 bg-white shadow-sm border-bottom border-danger border-5"
                >
                    <!-- Text Section -->
                    <div class="col-12">
                        <h1 class="mb-5">Just one more step…</h1>

                        <p class="mb-4">
                            <strong
                                >We have sent you an email with a link to
                                confirm your details.</strong
                            >
                            If you can't find it, please check in your junk
                            folder.
                        </p>

                        <p class="mb-4">
                            We need you to click the link in the confirmation
                            email, so we can create your My King's Trust
                            account.
                        </p>

                        <p class="mb-5">
                            If you can't find the email, please get in touch
                            with your King's Trust team member. Or <a href="https://www.kingstrust.org.uk/contact-us" target="_blank" rel="noopener">contact us</a>.
                        </p>

                        <a
                            href="https://www.kingstrust.org.uk/contact-us"
                            class="btn btn-primary px-4"
                            target="_blank"
                            rel="noopener"
                        >
                            Need help? Contact us
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
